import { Component, OnInit, ViewChild } from '@angular/core';
import * as ngswal from "sweetalert";
import { ApiMethod } from '../apimethods/api-method';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalConstants } from '../common/global-constants';
import { DefectManagementModel } from './defect-management-model'
import { customfunctions, DataParam } from '../common/customfunctions';
import { PlotVbpVolumeDivisionOptions } from 'highcharts';
import { NgForm } from '@angular/forms';

declare var $;

@Component({
  selector: 'app-defect-management',
  templateUrl: './defect-management.component.html',
  styleUrls: ['./defect-management.component.css']
})
/** defect-management component*/
export class DefectManagementComponent implements OnInit {
  modelItem: DefectManagementModel = new DefectManagementModel();
  dtOptions: any; tableData = [];
  dataTable: any; @ViewChild('dataTable', { static: false }) table; dataSet: any;
  journalList: any; issueList: any; articleList: any;
  DefectAreaList: any; DefectCategoryList: any; DefectInstructionList: any;
  DefectStatusListAPI: any;
  CategoryIdPop: any; Acronym: string; ArticleNo: string; VolIssue: string; AreaName: string;
  Category: string; Instructions: string; ResponseMode: string;
  Volume: any;
  Description: any;
  title: string;
  showModal: boolean;
  DownloadFilepath: any;
  popUpButtonText: string;
  Response: string;
  file: any;
  fileBase64: any;
  FileName: any;
  uploadFilePath: any;
  RequestFeedback: any;
  reportTypeList: any;
  DefectDueDate: any;
  disableValidation: boolean = false;
  minDate: string;
  maxDate: string;
  status: string;
  RootCauseDates: any;
  PreventiveDates: any;
  CorrectiveDates: any;
  JournalId: string;
  DefectStatus: any;
  DefectId: any;

  constructor(private router: Router, private route: ActivatedRoute) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <DefectManagementModel>data["DefectManagementModel"];

        if (localStorage.aEID == 0) {

          this.GetDefectList();
        }
        if (localStorage.aEID != 0) {
          this.ShowInfoPopUp();
        }
        this.GetJournalsList();
        this.GetDefectAreaList();
        this.GetDefectInstruction();
        this.GetStatusList();
        this.loadGeneralmethod();
        this.getReportTypeList();
        this.GetDueDateValidation();
        this.GetVolIssArt();

        $("#DefectStatus").select2({
          placeholder: "Select Status", dropdownParent: "#divResponseData",
          allowClear: true, tags: true,
        });
        $("#DefectStatus").val([]).trigger("change");

        $("#ddlDefectCategory").select2({
          placeholder: "Select Status", dropdownParent: "#DivAddData"
        });
        $("#ddlDefectCategory").val([]).trigger("change");

        $("#ddlFeedbackRequest").select2({
          placeholder: "No", dropdownParent: "#DivAddData"
        });
        $("#ddlFeedbackRequest").val([]).trigger("change");

      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      if (params.get("JournalId") != null) {
        this.JournalId = params.get("JournalId");
      }
    });
    this.route.queryParams.subscribe(params => {
      if (params.DefectStatus == 'Defect' && params.DefectId == 0) {
        this.DefectStatus = params.DefectStatus;
        localStorage.aEID = params.DefectId;
        this.ShowInfoPopUp();

      }
      if (params.DefectStatus == 'Journal' && params.JournalId != 0) {
        this.DefectStatus = params.DefectStatus;
        this.JournalId = params.JournalId;
        $("#lstJournals").val(params.JournalId).change();
        this.GetDefectList();
      }
      if (params.DefectStatus == 'Defect' && params.DefectId != 0) {// to give response to already existing defect
        this.DefectStatus = params.DefectStatus;
        this.DefectId = params.DefectId;
        this.ShowInfoPopUp();
      }
    });
  }


  loadGeneralmethod() {

    $('.select2').select2({ dropdownParent: '#divMainFilter', placeholder: "Select Journals" });
    $('.ddlselect').val([]).trigger('change');
    ApiMethod.getBaseUrl();
    $('#divDataBody').css('height', GlobalConstants.size.height - 140);
    $('#txtDescription,#txtDefetResponse').css('height', GlobalConstants.size.height - 460);
    $('#Txt_rootCause, #Txt_PreventiveAction,#Txt_CorrectiveAction').css('height', GlobalConstants.size.height - 620);
  }


  resetFilter() {
    this.JournalId = null;
    $('#lstJournals').val(0).change();
    this.GetDefectList();
  }

  GetJournalsList() {
    ApiMethod.getMethod(this.modelItem.JournalListApi + "/" + localStorage.aPubID + "/" + localStorage.aLoginID).subscribe(
      result => {
        this.journalList = result.aitemJournalList;

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }
  GetVolIssArt() {
    var dataParam = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      JournalId: $('#ddlJournals').val()
    };
    ApiMethod.postMethod(this.modelItem.IssueAndArticlesListApi, dataParam).subscribe(
      result => {
        this.articleList = result.ArticleList;
        this.issueList = result.VolIssueList;
        $("#ddlIssue").val(0).change();
        $("#ddlArticle").val(0).change();
      }, error => {
        $("#LoadingImage").hide();
      });
  }

  GetDefectAreaList(): void {
    ApiMethod.getMethod(this.modelItem.DefectAreaList).subscribe(
      result => {
        this.DefectAreaList = result.dataItem;

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed to Load Defect Area !", error.message, "error");
      });
  }

  GetDefectCategoryList(selectedId = 0): void {
    var dataParam = {
      DefectAreaId: $("#ddlDefectArea").val()
    };
    ApiMethod.postMethod(this.modelItem.DefectCategoryList, dataParam).subscribe(
      result => {
        this.DefectCategoryList = result.dataItem;
        this.CategoryIdPop = selectedId;
      }, error => {
        $("#LoadingImage").hide();

      });
  }

  GetDefectInstruction(): void {
    ApiMethod.getMethod(this.modelItem.DefectInstructionList).subscribe(
      result => {
        this.DefectInstructionList = result.dataItem;

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed to Load Defect Instruction !", error.message, "error");
      });
  }
  GetStatusList(): void {

    ApiMethod.getMethod(this.modelItem.DefectStatusListAPI).subscribe(
      result => {
        this.DefectStatusListAPI = result.dataItem;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed to Load Defect Status !", error.message, "error");
      });
  }
  getReportTypeList() {
    ApiMethod.getMethod(this.modelItem.ReportTypeAPI + "/" + localStorage.roleId).subscribe(
      result => {
        this.reportTypeList = result.areportType;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  GetDueDateValidation() {

    var today = new Date();
    var tenDaysFromNow = new Date(today.getTime() + 10 * 24 * 60 * 60 * 1000);
    this.minDate = today.toISOString().slice(0, 10);
    this.maxDate = tenDaysFromNow.toISOString().slice(0, 10);
    var dueDate = new Date('dd-mm-yyyy');

    if (dueDate > today) {
      ngswal("Warning !", "Due date must be today or in the past", "warning");
    } else if (dueDate > tenDaysFromNow) {
      ngswal("Warning !", "Due date must be within 10 days from today", "warning");
    }
  }


  BacktoDashBoard() {
    this.router.navigate(['/defect-dashboard']);
    this.ClearData();
    this.GetDefectList();
  }

  GetDefectList() {
    $("#LoadingImage").hide();
    if (this.DefectStatus == 'Defect') {
      return false;
    }
    $("#LoadingImage").show();
    if (this.JournalId == null) {
      this.JournalId = $('#lstJournals').val().toString();
    }
    $("#lstJournals").val(this.JournalId).change();
    var dataParam = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      JournalIdList: this.JournalId ,
    };
    ApiMethod.postMethod(this.modelItem.DefectManagementList, dataParam).subscribe(
      result => {
        this.dataSet = JSON.stringify(result.DefectData); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);
        //Dynamic datable
        let columnList = result.ColumnList;
        let dataItem = new DataParam();
        dataItem.acolList = columnList;
        dataItem.aNewButtonName = 'btnAddNew';
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 220);
        dataItem.modulename = 'DefecMgtDashboard';
        dataItem.infoPopupID = 'Id';
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable
        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }
  hide(): void {
    $('#divListData').show();
    $('#DivAddData').hide();
    $('#divResponseData').hide();
    this.GetDefectList();
    this.ClearData();

  }

  ShowInfoPopUp(): void {
    $("#LoadingImage").show();
    $('#divResponseData').hide();
    $('#DivAddData').show();
    this.ClearData();
    $("#textbuttonh").show();
    $("#textresponseif").hide();
    if (localStorage.aEID != 0) {
      var dataParam = {
        Id: localStorage.aEID,
        UpdatedBy: localStorage.aLoginID,
      };
      console.log(dataParam);

      ApiMethod.postMethod('api/populatedefectmgt', dataParam).subscribe(
        result => {
          let _dataItem = result.DataItem;
          let _defectdata = result.defectData;
          //Role Based UI Changes
          var menuList = JSON.parse(localStorage.aMenuList);
          var RootCauseAnalysis = menuList.find(
            (menuItem) => menuItem.MenuID == 77);

          var PreventiveAction = menuList.find(
            (menuItem) => menuItem.MenuID == 78);

          var CorrectiveAction = menuList.find(
            (menuItem) => menuItem.MenuID == 79);
          var Approver = menuList.find((menuItem) => menuItem.MenuID == 87);
          var Reject = menuList.find((menuItem) => menuItem.MenuID == 88);

          if (Reject && Reject.Action.toLowerCase().includes('update') == true) {

            $("#Txt_rootCause").prop('disabled', true);
            $("#Txt_PreventiveAction").prop('disabled', true);
            $("#Txt_CorrectiveAction").prop('disabled', true);
          }


          //Preventive Action User View
          let Rootcause = (_dataItem[0].RootCasue || '').trim();
          if (Rootcause.toString() != '') {

            if (PreventiveAction.Action.toLowerCase().includes('update') == true) {
              $("#Txt_rootCause").prop('disabled', true);
              $("#Txt_PreventiveAction").prop('disabled', false);
              $("#Txt_CorrectiveAction").prop('disabled', true);
            }
            else {

              $("#Txt_rootCause").prop('disabled', true);
              $("#Txt_PreventiveAction").prop('disabled', true);
              $("#Txt_CorrectiveAction").prop('disabled', true);

            }
          }
          else {

            $("#Txt_rootCause").prop('disabled', true);
            $("#Txt_PreventiveAction").prop('disabled', true);
            $("#Txt_CorrectiveAction").prop('disabled', true);

          }
          //RootCause User View
          if (RootCauseAnalysis.Action.toLowerCase().includes('update')) {
            $("#Txt_rootCause").prop('disabled', false);
            $("#Txt_PreventiveAction").prop('disabled', true);
            $("#Txt_CorrectiveAction").prop('disabled', true);
          }
          //Root Cause and Preventive Action Access 
          if (RootCauseAnalysis.Action.toLowerCase().includes('update') == true && PreventiveAction.Action.toLowerCase().includes('update') == true) {
            $("#Txt_rootCause").prop('disabled', false);
            $("#Txt_PreventiveAction").prop('disabled', false);
            $("#Txt_CorrectiveAction").prop('disabled', true);
          }
          //Corrective User View
          if (CorrectiveAction.Action.toLowerCase().includes('update') == true) {
            $("#Txt_PreventiveAction").prop('disabled', true);
            $("#Txt_rootCause").prop('disabled', true);
            $("#Txt_CorrectiveAction").prop('disabled', false);
          }
          //Root Cause and Preventive Action Access 
          if (RootCauseAnalysis.Action.toLowerCase().includes('update') == true
            && PreventiveAction.Action.toLowerCase().includes('update') == true
            && CorrectiveAction.Action.toLowerCase().includes('update') == true
          ) {
            $("#Txt_rootCause").prop('disabled', false);
            $("#Txt_PreventiveAction").prop('disabled', false);
            $("#Txt_CorrectiveAction").prop('disabled', false);
          }

          //Show Data
          if (_dataItem.length != 0) {
            this.uploadFilePath = _dataItem[0].Attachments;
            $("#ddlJournals").val(_dataItem[0].JournalId).change();
            $("#ddlIssue").val(_dataItem[0].IssueId).change();
            $("#ddlArticle").val(_dataItem[0].ArticleId).change();

            $("#ddlDefectArea").val(_dataItem[0].DefectAreaId).change();
            $("#ddlDefectCategory").val(_dataItem[0].DefectCategoryId).change();
            this.ResponseMode = _dataItem[0].DefectViewProcess;
            //Populate Category from Area and Selected Id
            this.GetDefectCategoryList(_dataItem[0].DefectCategoryId);
            $("#ddlDefectInstruction").val(_dataItem[0].DefectInstructionId).change();
            $("#ddlFeedbackRequest").val(_dataItem[0].RequestFeedback).change();
            $("#txtDescription").val(_dataItem[0].Description);
            if (_dataItem[0].DefectDueDate != null) {
              $("#Txt_DefectDueDate").val(GlobalConstants.SetValue_FormatDate(_dataItem[0].DefectDueDate));
            }

            //Reponse Data 
            if (_defectdata[0].DefectViewProcess == 'Response') {
              $('#defcorrectuploadbtn').show();
              $('#DownloadCorrectFile').hide();
              $('#Status').hide();
              $('#DefectComments').hide();
              this.Acronym = _defectdata[0].Acronym;
              this.ArticleNo = _defectdata[0].ArticleNo;
              this.VolIssue = _defectdata[0].Volume;
              this.AreaName = _defectdata[0].AreaName;
              this.Category = _defectdata[0].Category;
              this.Instructions = _defectdata[0].Instructions;
              this.Description = _defectdata[0].Description;
              this.DefectDueDate = _defectdata[0].DefectDueDate;
              this.uploadFilePath = _dataItem[0].Attachments;
              $("#txtDefectResponse").val(_dataItem[0].ProductionResponse);
              $("#Txt_RootCauseuser").val(localStorage.aLoginName);
              $("#Txt_ResponsibleUser").val(_dataItem[0].ResponsiblePerson);
              $("#ddlComplaintType").val(_dataItem[0].ComplaintType).change();
              $("#ddlCriticalLevel").val(_dataItem[0].CriticalLevel).change();
              $("#Txt_Implement").val(_dataItem[0].ImplementDate);
              $("#Txt_Problem").val(_dataItem[0].ProblemDate);
              $("#Txt_rootCause").val(_dataItem[0].RootCasue);
              $("#Txt_CorrectiveAction").val(_dataItem[0].CorrectiveAction);
              $("#Txt_PreventiveAction").val(_dataItem[0].PreventiveAction);
              $("#DefectStatus").val(_dataItem[0].DefectStatus).change();
              $('#divResponseData').show();
              $('#DivAddData').hide();
              this.Response = "Defect Response Details";
            }
            if (_dataItem[0].RootCasue != null) {
              this.DisablepopupAdd();
              $("#UpdateAdd").hide();
            }

          }
        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "warning");
        });

      $("#LoadingImage").hide();
      this.title = "Update Defect Details"; //Dynamic Data
      this.popUpButtonText = "Update";
    }
    else {
      this.title = "Add Defect Details"; // Dynamic Data
      this.popUpButtonText = "Save";
      $("#LoadingImage").hide();
    }

  }

  //Response Status View Approve And Reject 
  ShowDataResponse(): void {
    this.ClearData();
    $("#LoadingImage").show();
    $('#divResponseData').hide();
    $('#DivAddData').show();
    this.ClearData();
    $("#textbuttonh").show();
    $("#textresponseif").hide();
    if (localStorage.aEID != 0) {
      var dataParam = {
        Id: localStorage.aEID,
        UpdatedBy: localStorage.aLoginID,
      };
      ApiMethod.postMethod('api/populatedefectmgt', dataParam).subscribe(
        result => {

          let _dataItem = result.DataItem;
          let _defectdata = result.defectData;
          //Role Based UI Changes
          var menuList = JSON.parse(localStorage.aMenuList);
          var Approver = menuList.find((menuItem) => menuItem.MenuID === 87);
          var Reject = menuList.find((menuItem) => menuItem.MenuID === 88);
          if (Approver && Reject && (Approver.Action.toLowerCase().includes('update') || Reject.Action.toLowerCase().includes('update'))) {
            $("#txtDefectResponse").prop('disabled', false);
            $("#DefectStatus").prop('disabled', false);
          } else {
            $("#DefectStatus").prop('disabled', true);
            $("#txtDefectResponse").prop('disabled', true);
          }
          //Show Data
          if (_dataItem.length != 0) {
            this.uploadFilePath = _dataItem[0].Attachments;
            $("#ddlJournals").val(_dataItem[0].JournalId).change();
            $("#ddlArticle").val(_dataItem[0].ArticleId).change();
            $("#ddlIssue").val(_dataItem[0].IssueId).change();
            $("#ddlDefectArea").val(_dataItem[0].DefectAreaId).change();
            $("#ddlDefectCategory").val(_dataItem[0].DefectCategoryId).change();
            this.ResponseMode = _dataItem[0].DefectViewProcess;
            //Populate Category from Area and Selected Id
         
            $("#ddlDefectInstruction").val(_dataItem[0].DefectInstructionId).change();
            $("#ddlFeedbackRequest").val(_dataItem[0].RequestFeedback).change();
            $("#txtDescription").val(_dataItem[0].Description);

            if (_dataItem[0].DefectDueDate != null) {
              $("#Txt_DefectDueDate").val(GlobalConstants.SetValue_FormatDate(_dataItem[0].DefectDueDate));
            }
            //Reponse Data 
            if (_defectdata[0].DefectViewProcess == 'Add') {
              this.Disablepopupfields();
              this.Acronym = _defectdata[0].Acronym;
              this.ArticleNo = _defectdata[0].ArticleNo;
              this.VolIssue = _defectdata[0].Volume;
              this.AreaName = _defectdata[0].AreaName;
              this.Category = _defectdata[0].Category;
              this.Instructions = _defectdata[0].Instructions;
              this.Description = _defectdata[0].Description;
              this.DefectDueDate = _defectdata[0].DefectDueDate;
              this.uploadFilePath = _dataItem[0].Attachments;
              //Root Cause Data 
              $("#txtDefectResponse").val(_dataItem[0].ProductionResponse);
              $("#Txt_RootCauseuser").val(localStorage.aLoginName);
              $("#Txt_ResponsibleUser").val(_dataItem[0].ResponsiblePerson);
              $("#ddlComplaintType").val(_dataItem[0].ComplaintType).change();
              $("#ddlCriticalLevel").val(_dataItem[0].CriticalLevel).change();
              $("#Txt_rootCause").val(_dataItem[0].RootCasue);
              $("#Txt_CorrectiveAction").val(_dataItem[0].CorrectiveAction);
              $("#Txt_PreventiveAction").val(_dataItem[0].PreventiveAction);
              $("#DefectStatus").val(_dataItem[0].DefectStatus).change();
              $("#LoadingImagePopup").show();
              $('#defcorrectuploadbtn').hide();
              $('#DownloadCorrectFile').show();
              $('#divResponseData').show();
              $('#DivAddData').hide();

              this.Response = "Defect Response Details";
              this.popUpButtonText = "Update";
            }
            if (_defectdata[0].DefectViewProcess == 'Response') {
              this.Disablepopupfields();
              this.Acronym = _defectdata[0].Acronym;
              this.ArticleNo = _defectdata[0].ArticleNo;
              this.VolIssue = _defectdata[0].Volume;
              this.AreaName = _defectdata[0].AreaName;
              this.Category = _defectdata[0].Category;
              this.Instructions = _defectdata[0].Instructions;
              this.Description = _defectdata[0].Description;
              this.DefectDueDate = _defectdata[0].DefectDueDate;
              this.uploadFilePath = _dataItem[0].Attachments;
              $("#txtDefectResponse").val(_dataItem[0].ProductionResponse);
              $("#Txt_RootCauseuser").val(localStorage.aLoginName);
              $("#Txt_ResponsibleUser").val(_dataItem[0].ResponsiblePerson);
              $("#ddlComplaintType").val(_dataItem[0].ComplaintType).change();
              $("#ddlCriticalLevel").val(_dataItem[0].CriticalLevel).change();
              $("#Txt_rootCause").val(_dataItem[0].RootCasue);
              $("#Txt_CorrectiveAction").val(_dataItem[0].CorrectiveAction);
              $("#Txt_PreventiveAction").val(_dataItem[0].PreventiveAction);
              $("#DefectStatus").val(_dataItem[0].DefectStatus).change();
              $("#LoadingImagePopup").show();
              $('#defcorrectuploadbtn').hide();
              $('#divResponseData').show();
              $('#DivAddData').hide();
              this.Response = "Defect Response Details";
              this.popUpButtonText = "Update";
            }
          }
        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "warning");
        });
      $("#LoadingImage").hide();
      this.title = "Update Defect Details"; //Dynamic Data
      this.popUpButtonText = "Update";
    } else {
      this.title = "Add Defect Details"; // Dynamic Data
      this.popUpButtonText = "Save";
      $("#LoadingImage").hide();
    }
  }
  //Add and Update the  Defect Data
  UpdateDefectMgt(): void {
    if ($("#ddlJournals").val() == 0) {
      ngswal("Warning !", "Please Select Journal !", "warning");
    }
    else if ($('#ddlDefectArea').val() == 0) {
      ngswal("Warning !", "Please Select Defect Area !", "warning");
    }
    else if ($('#ddlDefectCategory').val() == 0) {
      ngswal("Warning !", "Please Select Defect Category !", "warning");
    }

    else if ($('#ddlDefectInstruction').val() == 0) {
      ngswal("Warning !", "Please Select Defect Instruction !", "warning");
    }
    else if ($('#Txt_DefectDueDate').val() == '') {
      ngswal("Warning !", "Please Enter Defect Due Date !", "warning");
    }
    else if ($('#txtDescription').val() == '') {
      ngswal("Warning !", "Please Enter Defect Description !", "warning");
    }
    
    else {
      let fileName = null;
      let fileSize = null;
      if (this.file != null) {
        fileName = this.file.name;
        fileSize = this.file.size;
      } else {
        this.fileBase64 = null;
      }
      var dataParam = {
        Id: localStorage.aEID,
        JournalId: $("#ddlJournals").val(),
        IssueId: $("#ddlIssue").val(),
        ArticleId: $("#ddlArticle").val(),
        DefectAreaId: $("#ddlDefectArea").val(),
        DefectCategoryId: $("#ddlDefectCategory").val(),
        DefectInstructionId: $("#ddlDefectInstruction").val(),
        RequestFeedback: $("#ddlFeedbackRequest").val(),
        Description: $("#txtDescription").val(),
        DefectDueDate: $("#Txt_DefectDueDate").val(),
        ProductionResponse: $("#txtDefectResponse").val(),
        DefectStatus: $("#DefectStatus").val(),
        RespondedBy: localStorage.roleId,
        UpdatedBy: localStorage.aLoginID,
        PublisherId: localStorage.aPubID,
        fileName: fileName,
        fileSize: fileSize,
        fileAsBase64: this.fileBase64,

      };

      ApiMethod.postMethod(this.modelItem.UpdateDefectManagement, dataParam).subscribe(
        result => {
          if (this.DefectStatus == 'Defect') {
            this.BacktoDashBoard();
          }
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: result.dataItem,
            showConfirmButton: true,
          });
          this.hide();
          $("#LoadingImage").hide();
        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "warning");
        });
    }
  }

  //Add the Defect Response Data
  UpdateDefectMgtResponse(): void {

    if (!$("#Txt_rootCause").prop('disabled') && $("#Txt_rootCause").val().trim() == '') {
      ngswal("Warning !", "Please Enter The RootCause Data !", "warning");
      return;
    }

    if (!$("#Txt_PreventiveAction").prop('disabled') && $("#Txt_PreventiveAction").val().trim() == '') {
      ngswal("Warning !", "Please Enter The Preventive Data!", "warning");
      return;
    }
    if (!$("#Txt_CorrectiveAction").prop('disabled') && $("#Txt_CorrectiveAction").val().trim() == '') {
      ngswal("Warning !", "Please Enter The Corrective Data !", "warning");
      return;
    }
    else {
      let fileName = null;
      let fileSize = null;
      if (this.file != null) {
        fileName = this.file.name;
        fileSize = this.file.size;
      } else {
        this.fileBase64 = null;
      }
      var dataParam = {
        Id: localStorage.aEID,
        RespondedBy: localStorage.roleId,
        RootCasueUser: $("#Txt_RootCauseuser").val(),
        ResponsiblePerson: $("#Txt_ResponsibleUser").val(),
        ComplaintType: $("#ddlComplaintType").val(),
        CriticalLevel: $("#ddlCriticalLevel").val(),
        RootCasue: $("#Txt_rootCause").val(),
        RootCasueBy: 0,
        CorrectiveAction: $("#Txt_CorrectiveAction").val(),
        CorrectiveActionBy: 0,
        PreventiveAction: $("#Txt_PreventiveAction").val(),
        PreventiveActionBy: 0,
        UpdatedBy: localStorage.aLoginID,
        PublisherId: localStorage.aPubID,
        fileName: fileName,
        fileSize: fileSize,
        fileAsBase64: this.fileBase64,

      };

      if (dataParam.RootCasue.toString() !== '' || dataParam.PreventiveAction.toString() !== '') {
        if (dataParam.RootCasue.toString() !== '') {
          dataParam.RootCasueBy = localStorage.roleId;

        }
        if (dataParam.PreventiveAction.toString() !== '') {
          dataParam.PreventiveActionBy = localStorage.roleId;

        }
      }

      if (dataParam.CorrectiveAction.toString() !== '') {
        dataParam.CorrectiveActionBy = localStorage.roleId;

      }

      ApiMethod.postMethod('api/UpdateDefectResponse', dataParam).subscribe(
        result => {
          if (this.DefectStatus == 'Defect') {
            this.BacktoDashBoard();
          }
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: result._aItem,
            showConfirmButton: true,
          });
          this.hide();
          $("#LoadingImage").hide();
        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "warning");
        });
    }
  }


  Disablepopupfields() {
    $('#Txt_RootCauseuser').attr('disabled', 'disabled');
    $('#Txt_ResponsibleUser').attr('disabled', 'disabled');
    $('#ddlComplaintType').attr('disabled', 'disabled');
    $('#ddlCriticalLevel').attr('disabled', 'disabled');
    $('#Txt_rootCause').attr('disabled', 'disabled');
    $('#Txt_CorrectiveAction').attr('disabled', 'disabled');
    $('#Txt_RootCauseuser').attr('disabled', 'disabled');
    $('#Txt_PreventiveAction').attr('disabled', 'disabled');

  }
  DisablepopupAdd() {
    $("#ddlJournals").attr('disabled', 'disabled');
    $("#ddlIssue").attr('disabled', 'disabled');
    $("#ddlArticle").attr('disabled', 'disabled');
    $("#ddlDefectArea").attr('disabled', 'disabled');
    $("#ddlDefectCategory").attr('disabled', 'disabled');
    $("#ddlDefectInstruction").attr('disabled', 'disabled');
    $("#txtDescription").attr('disabled', 'disabled');
    $("#Txt_DefectDueDate").attr('disabled', 'disabled');
    $("#doc_Defectuploadfile").attr('disabled', 'disabled');
    $("#ddlFeedbackRequest").attr('disabled', 'disabled');
  }

  ClearData(): void {
    $("#ddlJournals").val(0).change();
    $("#ddlDefectArea").val(0).change();
    $("#ddlDefectCategory").val(0).change();
    $("#ddlDefectInstruction").val(0).change();
    $("#txtDescription").val('');
    $("#Txt_DefectDueDate").val('');
    $("#ddlCurrentStatus").val(0).change();
    $("#ddlFeedbackRequest").val(0).change();
    $("#txtDefectResponse").val('').change();
    $("#Txt_RootCauseuser").val('').change();
    $("#Txt_ResponsibleUser").val('').change();
    $("#ddlComplaintType").val(0).change();
    $("#ddlCriticalLevel").val(0).change();
    $("#Txt_rootCause").val('').change();
    $("#Txt_CorrectiveAction").val('');
    $("#Txt_PreventiveAction").val('');
    $("#textresponseif").val('').change();
    $('#Responsetab').val('').change();
    $('#DefectStatus').val(0).change();
    $("#Txt_DefectDueDate").val('').change();

  }

  resetForm() {
    let form: NgForm = $('form');
    form[0].reset();
    $('form input').val('');

  }
  //Upload Method
  onuploadSelected(fileInput: any) {

    var ext = $('#doc_Defectuploadfile').val().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['doc', 'docx', 'pdf']) == -1) {
      $('#doc_Defectuploadfile').val("");
      ngswal("Failed !", "Invalid File format", "warning");
      return false;
    } else if (fileInput.target.files[0].size > 52428800) {
      $('#doc_Defectuploadfile').val("");
      ngswal("Failed !", "Please upload File less than 50MB", "warning");
      return;
    } else {
      this.file = fileInput.currentTarget.files[0];
      if (fileInput.currentTarget.files[0]) {

        var fileReader = new FileReader();
        fileReader.onload = (e: any) => {
          this.fileBase64 = null;
          this.fileBase64 = e.currentTarget.result;
        }
        fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
      }
    }
  }
  onuploadDataSelected(fileInput: any) {
    var ext = $('#doc_DefectCorrectedFile').val().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['doc', 'docx', 'pdf']) == -1) {
      $('#doc_DefectCorrectedFile').val("");
      ngswal("Failed !", "Invalid File format", "warning");
      return false;
    } else if (fileInput.target.files[0].size > 52428800) {
      $('#doc_DefectCorrectedFile').val("");
      ngswal("Failed !", "Please upload File less than 50MB", "warning");
      return;
    } else {
      this.file = fileInput.currentTarget.files[0];
      if (fileInput.currentTarget.files[0]) {

        var fileReader = new FileReader();
        fileReader.onload = (e: any) => {
          this.fileBase64 = null;
          this.fileBase64 = e.currentTarget.result;
        }
        fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
      }
    }
  }
  //Support File Download
  DefectDownloadFile() {
    $("#LoadingImage").show();
    var aEid = localStorage.aEID;
    ApiMethod.Downloadfile(this.modelItem.DefectFileDownloadApi + "/" + aEid);
    this.ShowInfoPopUp()
    this.hide();
    $("#LoadingImage").hide();
  }

  //Corrected Download File
  DefectCorrectedFile() {
    $("#LoadingImage").show();
    var aEid = localStorage.aEID;
    ApiMethod.Downloadfile(this.modelItem.DefectCorrectedFileDownload + "/" + aEid);
    this.ShowInfoPopUp();
    this.hide();
    $("#LoadingImage").hide();
  }


}
